import { Eyebrow } from "./Eyebrow";

const PILARES = [
  {
    title: "Diferenciação real no portfólio",
    desc: "Você passa a oferecer um produto que dificilmente os concorrentes têm na prateleira. Sai do menu padrão e oferece produtos que até hoje ficavam restritos aos investidores institucionais e quase nunca chegavam ao varejo.",
  },
  {
    title: "Lastro em operação real, não em promessa",
    desc: "Produtos de crédito estruturado com lastro real, sobregarantia e estruturas robustas de securitização.",
  },
  {
    title: "Remuneração competitiva para os assessores",
    desc: "Estrutura de remuneração acima da média do mercado para o parceiro. Detalhes apresentados na reunião 1:1, alinhados ao volume divulgado.",
  },
  {
    title: "Suporte comercial direto",
    desc: "Nossa equipe fornece tudo o que você precisa para dominar e apresentar o produto. Material de apresentação, treinamento de produto e respostas rápidas quando seu cliente perguntar. Temos um time 100% dedicado ao pós-vendas.",
  },
];

export const ParceirosOferta = () => {
  return (
    <section className="bg-[#FAF8F5] py-14 sm:py-16 md:py-20">
      <div className="container-wide">
        <div>
          <div className="flex justify-center mb-10 sm:mb-12">
            <Eyebrow>Por que ser parceiro</Eyebrow>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 gap-5 sm:gap-6">
          {PILARES.map((p) => (
            <div key={p.title}>
              <div
                className="bg-[#112711] rounded-3xl p-7 sm:p-8 h-full shadow-2xl shadow-[#112711]/20 ring-1 ring-[#1f4a2b]/50"
                style={{
                  fontFamily:
                    '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
                }}
              >
                <h3
                  className="text-lg sm:text-xl font-semibold text-white tracking-tight"
                  style={{ letterSpacing: "-0.01em" }}
                >
                  {p.title}
                </h3>
                <p className="mt-4 text-sm sm:text-base text-[#D1F8E2]/80 leading-relaxed">
                  {p.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
